<template>
    <div class="wrapper">
        <div class="spinner">
            <half-circle-spinner
                    :animation-duration="1000"
                    :size="300"
                    color="#ff1d5e"
            />
        </div>
        <div class="data">
            <h2>Fetching...</h2>
            <div><b>Pages:</b> {{this.page}}</div>
            <div><b>Comments:</b> {{this.comments.length}}</div>
            <div><b>Submissions:</b> {{this.submissions.length}}</div>
            <el-button icon="el-icon-close" circle @click="stop"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {SelfBuildingSquareSpinner} from 'epic-spinners'
    import {HalfCircleSpinner} from 'epic-spinners'


    export default {
        props: {
            onStop: Function
        },
        components: {
            SelfBuildingSquareSpinner, HalfCircleSpinner
        },
        computed: {
            ...mapGetters(['allPosts', 'comments', 'submissions']),
            page() {
                return Math.ceil(this.allPosts.length / 25);
            }
        },
        methods:{
            stop(){
                // this.$emit('onStop');
                this.$props.onStop();
            }
        }
    }
</script>

<style scoped>
    i {
        font-size: 3em;
        width: 3em;
        display: block;
        color: white;
    }

    .wrapper {
        width: 300px;
        position: relative;
        text-align: center;
        height: 300px;
        margin:auto auto;
    }

    .data {
        left: 0;
        top: 25%;
        position: absolute;
        width: 300px;
    }

    .spinner {
        left: 0;
        top: 0;
        position: absolute;
    }

    .el-button {
        margin-top: 2em;
        opacity: .5;
        border: 1px solid rgba(0, 0, 0, 0.4);
    }
</style>

<style lang="scss">
    .spinner div.circle {
        &.circle-1 {
            border-top-color: #fc0 !important;
            border-width: 2px !important;
        }

        &.circle-2 {
            border-bottom-color: #fc0 !important;
            border-width: 2px !important;
        }
    }
</style>